//frontend/src/services/auth.js

import api from './api';

export const authService = {
    register: async (userData) => {
        const response = await api.post('/register/', userData);
        return response.data;
    },

    login: async (credentials) => {
        console.log('🔐 Tentative de connexion avec:', { username: credentials.username, passwordLength: credentials.password.length });
        console.log('🌐 API URL utilisée:', api.defaults.baseURL);

        try {
            const response = await api.post('/login/', credentials);
            console.log('✅ Réponse du serveur:', response.status, response.data);

            const { token } = response.data;

            localStorage.setItem('access_token', token);

            console.log('💾 Tokens sauvegardés dans localStorage');
            return response.data;
        } catch (error) {
            console.error('❌ Erreur de connexion:', error);
            console.error('📋 Détails de l\'erreur:', {
                status: error.response?.status,
                statusText: error.response?.statusText,
                data: error.response?.data,
                headers: error.response?.headers
            });
            throw error;
        }
    },

    logout: () => {
        localStorage.removeItem('access_token');
    },

    getCurrentUser: async () => {
        const response = await api.get('/user');
        return response.data.user;
    },

    isAuthenticated: () => {
        return !!localStorage.getItem('access_token');
    },
};
